import React, { useMemo } from 'react';
import ScrollContainer from '../../../../../Base/Components/ScrollContainer';
import InfiniteScroll from 'react-infinite-scroll-component';
import {
	CaseTypesDefaultColumns,
	CaseTypesTable,
	WorkplaceMedicalProcedure,
} from '../../../../Consts/CaseTypesDefaultColumns.const';
import DataTable from '../../../../../Base/Components/DataTable/DataTable';
import Loading from '../../../../../../Components/Loading';
import OverlayLoading from '../../../../../../Components/OverlayLoading';
import useScrollGuard from '../../../../../Base/Hooks/useScrollGuard';

const WRAPPER_ID = 'caseTypesWrapper';

interface Props {
	data: WorkplaceMedicalProcedure[];
	isLoading: boolean;
	onRefresh: () => void;
	onLoadMore: () => void;
	hasMoreData: boolean;
	totalCount?: number;
}

const ManagerInsuranceCompaniesCaseTypesTable = ({
	data,
	isLoading,
	onRefresh,
	onLoadMore,
	hasMoreData,
	totalCount,
}: Props) => {
	const table = useMemo(
		() => ({
			refresh: onRefresh,
		}),
		[onRefresh],
	);

	const { scrollContainerRef } = useScrollGuard<WorkplaceMedicalProcedure>({
		data,
		isLoading,
		onLoadMore,
		hasMoreData,
	});

	return (
		<>
			{isLoading && <OverlayLoading />}
			<ScrollContainer wrapperId={WRAPPER_ID} ref={scrollContainerRef}>
				<InfiniteScroll
					dataLength={data.length}
					refreshFunction={onRefresh}
					next={onLoadMore}
					hasMore={hasMoreData}
					loader={<Loading />}
					scrollableTarget={WRAPPER_ID}>
					<DataTable<WorkplaceMedicalProcedure, CaseTypesTable>
						data={data}
						table={table}
						columns={CaseTypesDefaultColumns}
						totalCount={totalCount}
					/>
				</InfiniteScroll>
			</ScrollContainer>
		</>
	);
};

export default ManagerInsuranceCompaniesCaseTypesTable;
